import React, { useState, useEffect } from 'react'
import { Filter, DeleteCircle } from 'iconoir-react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import NotificationSystem from './../modules/NotificationSystem/NotificationSystem';
import NotificationGeneral from './../modules/NotificationGeneral/NotificationGeneral';
import { inject, observer } from 'mobx-react';
import Message from "../components/common/Message";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const NotificationPage = (props) => {
    const { notificationStore, handleClose } = props;
    const [value, setValue] = React.useState(0);
    const [tabSystem, setTabSystem] = useState(true);
    const [tabGeneral, setTabGeneral] = useState(false);
    const [openMessage, setOpenMessage] = useState(false);


    // api thông báo check xem đọc chưa
    useEffect(() => {
        notificationStore.getUnreadNotificationCount()
        notificationStore.getUnreadNewsCount()
    }, [])
    let unreadSystem = notificationStore.unreadNotificationCount;
    let unreadGeneral = notificationStore.unreadNewsCount;

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className='pt-6 px-5'>
            <div className="flex justify-between items-center mb-[16px]">
                <div className='flex items-center'>
                    <DeleteCircle className='w-[24px] h-[24px] mr-5 mt-1 cursor-pointer' onClick={handleClose} />
                    <div className="font-bold text-[28px] leading-[29px]  ">
                        Thông báo
                    </div>
                </div>
                <span className="w-5 cursor-pointer" onClick={() => { setOpenMessage(true) }}>
                    <Filter />
                </span>
            </div>
            <div className='custom-tabs'>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab
                                className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                                label="Tin hệ thống"
                                onClick={() => {
                                    setTabGeneral(false)
                                    setTabSystem(true)
                                }}
                                {...a11yProps(0)} />
                            <Tab
                                className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                                label="Tin báo chung"
                                onClick={() => {
                                    setTabGeneral(true)
                                    setTabSystem(false)
                                }}
                                {...a11yProps(1)} />

                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <NotificationSystem />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <NotificationGeneral />
                    </TabPanel>
                </Box>
                {unreadSystem > 0 ? tabSystem === false ? <div className='absolute left-[115px] top-[75px] w-2 h-2 bg-[#A2A2A2] rounded-full' /> : <div className='absolute left-[115px] top-[75px] w-2 h-2 bg-[#FF0000] rounded-full' /> : ''}
                {unreadGeneral > 0 ? tabGeneral === false ? <div className='absolute left-60 top-[75px] w-2 h-2 bg-[#A2A2A2] rounded-full' /> : <div className='absolute left-60 top-[75px] w-2 h-2 bg-[#FF0000] rounded-full' /> : ''}
                <Message message='Tính năng đang phát triển' openMessage={openMessage} closeMessage={() => {
                    setOpenMessage(false);
                }} />
            </div>
        </div>

    )
}

export default inject("notificationStore")(observer(NotificationPage));
